// Effects Style Plugin
import { createColorProperty } from "./helpers.js";
export default {
    id: 'effects',
    label: 'Effects',
    icon: 'Zap',
    properties: {
        boxShadow: {
            label: 'Shadow',
            type: 'select',
            options: ['2xs', 'xs', 'sm', 'default', 'md', 'lg', 'xl', '2xl', 'none'],
            default: 'none',
            toClass: (value) => {
                if (value === 'default') return 'shadow';
                return value ? `shadow-${value}` : null;
            },
            fromClass: (className) => {
                if (className === 'shadow') return 'default';
                const match = className.match(/^shadow-(2xs|xs|sm|md|lg|xl|2xl|none)$/);
                return match ? match[1] : null;
            }
        },
        boxShadowColor: {
            label: 'Shadow Color',
            type: 'color',
            default: null,
            toClass: (value) => {
                if (!value) return null;
                if (value.startsWith('#') || value.startsWith('rgb') || value.startsWith('hsl')) {
                    return `shadow-[${value}]`;
                }
                return `shadow-${value}`;
            },
            fromClass: (className) => {
                const match = className.match(/^shadow-(.+)$/);
                if (match) {
                    const colorValue = match[1];
                    // Handle bracket syntax
                    if (colorValue.startsWith('[') && colorValue.endsWith(']')) {
                        return colorValue.slice(1, -1);
                    }
                    // Exclude shadow size values
                    if (['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', 'none'].includes(colorValue)) return null;
                    return colorValue;
                }
                return null;
            }
        },
        textShadow: {
            label: 'Text Shadow',
            type: 'select',
            options: ['sm', 'default', 'md', 'lg', 'xl', 'none'],
            default: 'none',
            toClass: () => null, // Force inline styles as plugin is likely missing
            fromClass: (className) => {
                if (className === 'text-shadow') return 'default';
                const match = className.match(/^text-shadow-(.+)$/);
                if (match && ['sm', 'md', 'lg', 'xl', 'none'].includes(match[1])) return match[1];
                return null;
            }
        },
        textShadowColor: {
            label: 'Text Shadow Color',
            type: 'color',
            default: null,
            toClass: () => null, // Force inline styles
            fromClass: (className) => {
                const match = className.match(/^text-shadow-(.+)$/);
                if (match) {
                    const val = match[1];
                    if (val.startsWith('[') && val.endsWith(']')) return val.slice(1, -1);
                    if (!['sm', 'md', 'lg', 'xl', 'none'].includes(val)) return val;
                }
                return null;
            }
        },
        opacity: {
            label: 'Opacity',
            type: 'select',
            options: ['0', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90', '95', '100'],
            default: '100',
            toClass: (value) => value ? `opacity-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^opacity-(.+)$/);
                return match ? match[1] : null;
            }
        },
        mixBlendMode: {
            label: 'Mix Blend',
            type: 'select',
            options: ['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity', 'plus-darker', 'plus-lighter'],
            default: 'normal',
            toClass: (value) => value ? `mix-blend-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^mix-blend-(.+)$/);
                return match ? match[1] : null;
            }
        },
        backgroundBlendMode: {
            label: 'Background Blend',
            type: 'select',
            options: ['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity'],
            default: 'normal',
            toClass: (value) => value ? `bg-blend-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^bg-blend-(.+)$/);
                return match ? match[1] : null;
            }
        }
    }
};
